import React, { useEffect, useState } from "react";
import Accordion from "@material-ui/core/Accordion";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import ExpandMore from "@material-ui/icons/ExpandMore";
import { categoryImageFit } from "../presentation/imageFit";
import { formatMoney } from "../presentation/money";

export default function BubbleCategorySection({ category, settings, language, selectedCategoryID, children }) {
  const [expanded, setExpanded] = useState(!settings.collapsed_by_default || !!selectedCategoryID);
  useEffect(() => { if (selectedCategoryID) setExpanded(true); }, [selectedCategoryID]);
  const ar = language === "arabic";
  const name = ar ? category.ar_name || category.name : category.name;
  const cover = category.cover_photo_large || category.cover_photo;
  const minimum = Number(category.minimum_order_value);
  return <section className="sf-collapse-categories sf-bubble-section" dir={ar ? "rtl" : "ltr"} id={`navigate${category.id}`}>
    <Accordion expanded={expanded} onChange={(_, next) => setExpanded(next)}
      TransitionProps={{ unmountOnExit: true, timeout: window.matchMedia?.("(prefers-reduced-motion: reduce)").matches ? 0 : 180 }}>
      {cover && <img className="sf-browse-category__cover" src={cover} alt="" loading="lazy" style={{ objectFit: categoryImageFit(settings) }} />}
      <AccordionSummary expandIcon={<ExpandMore />} id={`bubble-${category.id}-header`} aria-controls={`bubble-${category.id}-content`}>
        <div className="sf-bubble-section__title">
          <h2>{name}</h2>
          {settings.show_prices !== false && !settings.is_menu && minimum > 0 && <small>
            {ar ? "الحد الأدنى للطلب: " : "Min. order: "}<bdi>{formatMoney(minimum, { settings, language })}</bdi>
          </small>}
        </div>
      </AccordionSummary>
      <AccordionDetails style={{ padding: 12, paddingTop: 0 }}>{children}</AccordionDetails>
    </Accordion>
  </section>;
}
